import React from "react";
import { LegalLayout, Section } from "@/components/legal/LegalLayout";

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-[color:var(--sg-fg)] leading-relaxed">{children}</p>
);

export const DPA: React.FC = () => (
  <LegalLayout
    testId="page-dpa"
    title="Data Processing Addendum"
    subtitle="Standard contractual terms for customers processing personal data of EU/UK/India data subjects."
    lastUpdated="February 13, 2026"
    seoPath="/dpa"
    seoDescription="SociBaba Data Processing Addendum (DPA) — GDPR / UK GDPR / DPDP compliant controller-processor terms and sub-processor list."
    seoKeywords={["DPA","data processing addendum","GDPR","DPDP","sub-processor list"]}
  >
    <Section n={1} title="Scope">
      <P>
        This Data Processing Addendum ("DPA") supplements the Terms of Service between you (the "Controller") and SociBaba (the "Processor") and applies whenever SociBaba processes personal data on your behalf.
      </P>
    </Section>
    <Section n={2} title="Subject-matter and duration">
      <P>
        We process personal data to provide the SociBaba service for the duration of your subscription, plus a 30-day deletion window on termination.
      </P>
    </Section>
    <Section n={3} title="Sub-processors">
      <P>Current sub-processors:</P>
      <ul className="list-disc ml-6 space-y-1 mt-2">
        <li>Emergent — hosting, object storage, LLM proxy</li>
        <li>Anthropic — Claude Sonnet 4.5 model provider (transient processing only)</li>
        <li>Google — OAuth authentication</li>
      </ul>
    </Section>
    <Section n={4} title="Security measures">
      <P>See our <a className="text-[color:var(--sg-primary)] hover:underline" href="/security">Security</a> page for technical and organisational measures.</P>
    </Section>
    <Section n={5} title="Request a signed DPA">
      <P>Email <a className="text-[color:var(--sg-primary)] hover:underline" href="mailto:legal@socibaba.com">legal@socibaba.com</a> and we will send a counter-signed PDF within 3 business days.</P>
    </Section>
  </LegalLayout>
);

export default DPA;
